export const featuredMatches = [
  {
    id: 'match-1',
    date: '2026-06-11',
    time: '20:00',
    timezone: 'UTC-5',
    venue: '阿兹特克体育场',
    city: '墨西哥城',
    homeTeam: '墨西哥',
    awayTeam: '待定',
    homeFlag: 'mx',
    awayFlag: 'tbd',
    stage: '揭幕战',
    status: 'upcoming',
  },
  {
    id: 'match-2',
    date: '2026-06-12',
    time: '16:00',
    timezone: 'UTC-4',
    venue: '大都会人寿体育场',
    city: '纽约/新泽西',
    homeTeam: '美国',
    awayTeam: '待定',
    homeFlag: 'us',
    awayFlag: 'tbd',
    stage: '小组赛',
    status: 'upcoming',
  },
  {
    id: 'match-3',
    date: '2026-06-12',
    time: '20:00',
    timezone: 'UTC-4',
    venue: 'BMO球场',
    city: '多伦多',
    homeTeam: '加拿大',
    awayTeam: '待定',
    homeFlag: 'ca',
    awayFlag: 'tbd',
    stage: '小组赛',
    status: 'upcoming',
  },
  {
    id: 'match-4',
    date: '2026-06-13',
    time: '18:00',
    timezone: 'UTC-7',
    venue: '索菲体育场',
    city: '洛杉矶',
    homeTeam: 'A1',
    awayTeam: 'A2',
    homeFlag: 'tbd',
    awayFlag: 'tbd',
    stage: '小组赛',
    status: 'upcoming',
  },
  {
    id: 'match-5',
    date: '2026-06-14',
    time: '15:00',
    timezone: 'UTC-5',
    venue: 'AT&T体育场',
    city: '达拉斯',
    homeTeam: 'B1',
    awayTeam: 'B2',
    homeFlag: 'tbd',
    awayFlag: 'tbd',
    stage: '小组赛',
    status: 'upcoming',
  },
  {
    id: 'match-6',
    date: '2026-06-15',
    time: '20:00',
    timezone: 'UTC-4',
    venue: '梅赛德斯-奔驰体育场',
    city: '亚特兰大',
    homeTeam: 'C1',
    awayTeam: 'C2',
    homeFlag: 'tbd',
    awayFlag: 'tbd',
    stage: '小组赛',
    status: 'upcoming',
  },
];

export const latestNews = [
  {
    id: 'news-1',
    title: '2026世界杯赛程正式公布：48支球队角逐美加墨',
    summary: '国际足联正式公布了2026年世界杯完整赛程，48支参赛球队将在美国、加拿大和墨西哥的16座城市展开为期39天的激烈角逐。揭幕战将于6月11日在墨西哥城具有传奇色彩的阿兹特克体育场拉开帷幕。',
    category: '赛程资讯',
    date: '2026-07-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20sports%20photography%20of%20packed%20football%20stadium%20at%20sunset%20with%20golden%20hour%20lighting%2C%20green%20pitch%2C%20dramatic%20sky%2C%20wide%20angle%20shot%2C%20atmospheric%20mood%2C%20warm%20tones%2C%20editorial%20quality&width=800&height=450&seq=news-2026-schedule-01&orientation=landscape',
  },
  {
    id: 'news-2',
    title: '2026世界杯抽签仪式确定：12月在迈阿密举行',
    summary: '国际足联确认2026年世界杯小组赛抽签仪式将于2025年12月在迈阿密举行，届时48支晋级球队的分组命运将一一揭晓，全球球迷翘首以盼的死亡之组是否会诞生？',
    category: '赛事动态',
    date: '2026-06-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20event%20venue%20with%20football%20themed%20stage%20design%2C%20gold%20and%20green%20color%20scheme%2C%20spotlights%2C%20championship%20trophy%20display%2C%20luxurious%20atmosphere%2C%20professional%20event%20photography&width=800&height=450&seq=news-draw-ceremony-02&orientation=landscape',
  },
  {
    id: 'news-3',
    title: '东道主美国队公布世界杯备战计划：剑指四强',
    summary: '美国国家队主教练公布了详细的2026世界杯备战计划，包括多场高质量热身赛安排和球员选拔方案。作为东道主之一，美国队志在主场创造历史最佳战绩。',
    category: '球队动态',
    date: '2026-06-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=American%20football%20soccer%20team%20training%20session%20on%20pristine%20green%20pitch%2C%20athletes%20in%20white%20and%20navy%20kit%2C%20dynamic%20action%20shot%2C%20bright%20sunlight%2C%20professional%20sports%20photography%2C%20clean%20stadium%20background&width=800&height=450&seq=news-usa-team-03&orientation=landscape',
  },
  {
    id: 'news-4',
    title: '世界杯球场巡礼：16座顶级场馆准备就绪',
    summary: '从纽约大都会人寿体育场到洛杉矶索菲体育场，2026世界杯16座比赛场馆的升级改造工程已进入最后冲刺阶段，每座场馆都配备了最新的科技设施和观赛体验系统。',
    category: '场馆介绍',
    date: '2026-06-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ultra%20modern%20football%20stadium%20aerial%20view%20at%20golden%20sunset%2C%20architectural%20masterpiece%20with%20retractable%20roof%2C%20surrounded%20by%20city%20skyline%2C%20dramatic%20lighting%2C%20professional%20architectural%20photography%2C%20warm%20atmospheric%20tones&width=800&height=450&seq=news-stadiums-04&orientation=landscape',
  },
  {
    id: 'news-5',
    title: '2026世界杯门票销售即将开启：购票攻略全解析',
    summary: '2026年世界杯门票销售阶段和时间安排已公布，本文为您详细解读各阶段售票规则、票价区间、以及如何提高抢票成功率的实用技巧，助您现场感受世界杯的魅力。',
    category: '观赛指南',
    date: '2026-06-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20FIFA%20World%20Cup%20match%20tickets%20and%20passport%20on%20wooden%20table%2C%20golden%20trophy%20in%20background%20with%20bokeh%20effect%2C%20warm%20lighting%2C%20aspirational%20travel%20aesthetic%2C%20premium%20product%20photography&width=800&height=450&seq=news-tickets-05&orientation=landscape',
  },
  {
    id: 'news-6',
    title: '世界杯新规解读：2026年将采用多项创新规则',
    summary: '国际足联宣布2026世界杯将试行多项创新比赛规则，包括扩大换人名额、引入更精准的半自动越位技术，以及首次在世界杯使用足球视频助理裁判系统的升级版本。',
    category: '规则解读',
    date: '2026-06-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20VAR%20video%20assistant%20referee%20technology%20room%20with%20multiple%20screens%20and%20soccer%20match%20footage%2C%20high%20tech%20environment%2C%20clean%20professional%20setting%2C%20green%20accent%20lighting%2C%20editorial%20tech%20photography&width=800&height=450&seq=news-rules-06&orientation=landscape',
  },
];

export const platformReviews = [
  {
    id: 'platform-1',
    name: 'Bet365',
    rating: 9.5,
    logo: 'ri-vip-crown-line',
    highlights: ['世界杯专属赔率', '高清直播覆盖', '24/7中文客服', '即时提款'],
    review: 'Bet365作为全球领先的体育博彩平台，为2026世界杯推出了专属的赛事投注页面。平台提供超过200种世界杯相关的投注选项，从冠军预测到单场比分，覆盖全面。高清赛事直播与实时数据更新确保您不会错过任何精彩瞬间。',
    bonus: '新用户首存100%匹配，最高¥888',
    url: 'http://cefotiam.com/go/bet365',
  },
  {
    id: 'platform-2',
    name: 'William Hill',
    rating: 9.2,
    logo: 'ri-shield-star-line',
    highlights: ['百年老牌信誉', '赔率最优', '多语言支持', '丰富玩法'],
    review: '成立于1934年的William Hill拥有近百年的体育博彩运营经验，在世界杯赛事投注方面积累了深厚的专业底蕴。平台2026世界杯专区提供赔率对比、专家分析和社区讨论功能，是资深球迷的首选。',
    bonus: '首投风险返还，最高¥500',
    url: 'http://cefotiam.com/go/williamhill',
  },
  {
    id: 'platform-3',
    name: '1xBet',
    rating: 8.8,
    logo: 'ri-fire-line',
    highlights: ['玩法最全', '高赔率', '快速结算', '加密货币支持'],
    review: '1xBet以极其丰富的投注玩法著称，2026世界杯专区提供超过500种不同的投注市场。无论是赛前投注还是滚球投注，1xBet都能提供流畅的操作体验和具有竞争力的赔率体系。',
    bonus: '首存四重豪礼，最高¥1,200',
    url: 'http://cefotiam.com/go/1xbet',
  },
];

export const faqItems = [
  {
    id: 'faq-1',
    question: '2026年世界杯在哪些国家举办？',
    answer: '2026年国际足联世界杯（第23届）由美国、加拿大和墨西哥三国联合主办，这是世界杯历史上首次由三个国家共同承办。比赛将在16座城市（美国11座、加拿大2座、墨西哥3座）的世界级体育场馆中举行。',
  },
  {
    id: 'faq-2',
    question: '2026年世界杯有多少支参赛队伍？',
    answer: '2026年世界杯将首次扩军至48支参赛球队，这是世界杯历史上参赛队伍最多的一届。小组赛将分为16个小组，每组3支球队，前两名晋级32强淘汰赛。',
  },
  {
    id: 'faq-3',
    question: '2026年世界杯什么时候开始和结束？',
    answer: '2026年世界杯将于6月11日（星期四）在墨西哥城阿兹特克体育场开幕，决赛将于7月19日（星期日）在纽约/新泽西大都会人寿体育场举行，整个赛事为期39天。',
  },
  {
    id: 'faq-4',
    question: '如何在线观看2026世界杯直播？',
    answer: '我们推荐的合规直播平台均提供2026世界杯高清直播服务。您可以通过本站推荐的认证平台观看全部104场比赛的超清直播，部分平台还支持多角度回放和实时数据叠加功能。',
  },
  {
    id: 'faq-5',
    question: 'ZL5.net是什么网站？安全吗？',
    answer: 'ZL5.net是2026世界杯官方信息聚合与服务平台，我们严格甄选并评测合规的在线观赛和投注平台，所有推荐平台均持有合法运营牌照。本站本身不提供投注服务，仅为用户提供安全入口导航和客观评测。',
  },
  {
    id: 'faq-6',
    question: '如何购买2026世界杯门票？',
    answer: '世界杯门票通过国际足联官方渠道发售。建议关注FIFA官网门票专区了解销售时间节点，一般分为抽签申请阶段、先到先得阶段和最后时刻销售阶段。我们会在资讯频道及时更新最新门票信息。',
  },
  {
    id: 'faq-7',
    question: '2026世界杯的比赛用球有什么特点？',
    answer: '2026世界杯官方比赛用球延续了高科技路线，内置精密传感器与惯性测量单元（IMU），可实时采集球的运动数据用于半自动越位判定。球的表面采用全新纹理设计以提升空气动力学性能，在高速飞行中更加稳定。',
  },
  {
    id: 'faq-8',
    question: '本站推荐投注平台的优势是什么？',
    answer: '我们推荐的每个平台都经过严格的多维度评测，包括：合法牌照验证、资金安全保障、赔率竞争力、中文服务品质、提款速度、用户口碑等。并且我们与平台合作争取了世界杯专属的新人福利，通过本站注册可享受额外优惠。',
  },
];

export const hostCities = [
  { name: '墨西哥城', country: '墨西哥', venue: '阿兹特克体育场', capacity: '87,523', matches: 5 },
  { name: '纽约/新泽西', country: '美国', venue: '大都会人寿体育场', capacity: '82,500', matches: 8 },
  { name: '洛杉矶', country: '美国', venue: '索菲体育场', capacity: '70,240', matches: 5 },
  { name: '达拉斯', country: '美国', venue: 'AT&T体育场', capacity: '80,000', matches: 9 },
  { name: '迈阿密', country: '美国', venue: '硬石体育场', capacity: '64,767', matches: 4 },
  { name: '亚特兰大', country: '美国', venue: '梅赛德斯-奔驰体育场', capacity: '71,000', matches: 8 },
  { name: '多伦多', country: '加拿大', venue: 'BMO球场', capacity: '45,500', matches: 3 },
  { name: '温哥华', country: '加拿大', venue: 'BC广场', capacity: '54,500', matches: 3 },
];

export const tournamentStats = [
  { label: '参赛球队', value: '48', suffix: '支', icon: 'ri-team-line' },
  { label: '比赛场次', value: '104', suffix: '场', icon: 'ri-football-line' },
  { label: '主办城市', value: '16', suffix: '座', icon: 'ri-building-line' },
  { label: '赛事天数', value: '39', suffix: '天', icon: 'ri-calendar-line' },
];

export const quickLinks = [
  { label: '赛事直播', url: '/category/all', icon: 'ri-live-line' },
  { label: '赛程赛果', url: '/category/all', icon: 'ri-calendar-check-line' },
  { label: '球队介绍', url: '/category/all', icon: 'ri-shield-line' },
  { label: '新闻资讯', url: '/category/all', icon: 'ri-newspaper-line' },
  { label: '平台评测', url: '/category/all', icon: 'ri-star-line' },
  { label: '观赛指南', url: '/category/all', icon: 'ri-guide-line' },
];